import { RenderMediaContent } from "src/components/RenderMediaContent";
import waitfor_commands from '../../assets/setup/waitfor_commands.mp4';
import CustomLink from "src/components/CustomLink";

interface Props {
    isMobileView: boolean;
}

export const PanelWaitForCommands: React.FC<Props> = ({ isMobileView }) => {
    return (
        <div className="flex flex-col justify-center gap-y-1">
            <p>You can use the following SAMMI: Wait for commands to display a popup in Deck Hopper that will wait for user input. The user can dismiss the dialog by manually interacting with it or by pressing Enter (on Desktop).</p>
            <ul className="flex flex-col gap-4 mt-4">
                <li>
                    <strong>Deck App: Wait for Input</strong> - Pauses a button execution for a specified time, showing a popup for user input. Parameters include Message, Default Text, Timeout After, and Save Variable As. <CustomLink url="https://sammi.solutions/docs/commands/321" text="Learn more" />
                </li>
                <li>
                    <strong>Deck App: Wait for Choice</strong> - Similar to Wait for Input, but it allows the user to make a choice. Parameters include Message, Timeout After, and Save Variable As. <CustomLink url="https://sammi.solutions/docs/commands/322" text="Learn more" />
                    
                </li>
                <li>
                    <strong>Deck App: Wait for Multi Choice</strong> - Offers a dropdown for user selection. Parameters include Message, Default Choice, Choice Array Name, Timeout After, and Save Variable As. <CustomLink url="https://sammi.solutions/docs/commands/323" text="Learn more" />
                    
                </li>
            </ul>
            <div className="mt-4">
            <p><CustomLink url="/deckhopper/wait_for_input_example_deck.txt" text="Download Example Deck" /> to see how it works. Once downloaded, simply copy the text inside the file, navigate to SAMMI Core and press Paste Deck.
            </p>
            </div>
            <RenderMediaContent src={waitfor_commands} />
        </div>
    )
}
